export default __webpack_public_path__ + "static/tic-tac-toe-1c176c1171448ec5f5282d6b9c5d1cf0.mp4";